exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".val-container {\n  padding: 24px;\n  background-color: #EEEEEE; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/validate-precio-financiera/validate-precio-financiera.component.scss
// module id = ../../../../../src/app/components/precios-seccion/financiera/validate-precio-financiera/validate-precio-financiera.component.scss
// module chunks = 0